export default __webpack_public_path__ + "static/media/roses.a45134d5.jpg";